import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:uuid",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "defaultHome" */ "../themes/default/views/Home.vue")
  },
  {
    path: "/:uuid/review",
    name: "Review",
    component: () =>
      import(/* webpackChunkName: "defaultReview" */ "../themes/default/views/Review.vue"),
  },
  {
    path: "/:uuid/:idmenu",
    name: "Dishes",
    component: () =>
      import(/* webpackChunkName: "defaultDishes" */ "../themes/default/views/Dishes.vue"),
    props: castRouteParams
  }
];

function castRouteParams(route) {
  return {
    idmenu: Number(route.params.idmenu),
  };
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
